/**
 * 指定した位置まで指定した時間でスクロールする関数
 * @param {number} targetPosition - スクロール先の位置（ピクセル）
 * @param {number} duration - スクロールにかける時間（ミリ秒）
 */
export function smoothScrollTo(targetPosition, duration) {
  const startPosition =
    window.pageYOffset || document.documentElement.scrollTop;
  const distance = targetPosition - startPosition;
  const startTime = performance.now();

  function step(currentTime) {
    const elapsedTime = currentTime - startTime;

    if (elapsedTime < duration) {
      // イージング関数（ここではイーズアウト）
      const progress = 1 - Math.pow(1 - elapsedTime / duration, 2);
      window.scrollTo(0, startPosition + distance * progress);
      requestAnimationFrame(step);
    } else {
      window.scrollTo(0, targetPosition);
    }
  }

  requestAnimationFrame(step);
}
